import React from "react";

const SecurityIcon = (props: any) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" clip-path="url(#clip0_3884_9196)">
        <path
          d="M10.0007 11.3332C10.0004 11.3332 10.0008 11.3332 10.0007 11.3332C10.2306 11.333 10.4175 11.1465 10.4173 10.9165V8.4165C10.4173 8.1864 10.2308 7.99984 10.0007 7.99984C9.77055 7.99984 9.58398 8.1864 9.58398 8.4165V10.9165C9.58398 10.9164 9.58398 10.9167 9.58398 10.9165C9.58414 11.1465 9.77065 11.3333 10.0007 11.3332ZM16.6585 3.62769C16.6114 3.40236 16.3905 3.25791 16.1652 3.30501C14.1075 3.73963 11.9618 3.30079 10.2399 2.09326C10.0964 1.99235 9.90493 1.99235 9.76139 2.09326C8.03949 3.30074 5.8938 3.73953 3.8361 3.30501C3.80813 3.29916 3.77964 3.29621 3.75106 3.29621C3.52085 3.29606 3.33414 3.48252 3.33398 3.71273V10.3949C3.33536 12.8417 4.51334 15.1387 6.49967 16.5675L9.75814 18.904C9.82879 18.9548 9.91362 18.9822 10.0007 18.9821C10.0877 18.9822 10.1725 18.9549 10.2432 18.904L13.5016 16.5675C15.488 15.1387 16.6659 12.8417 16.6673 10.3949V3.71273C16.6673 3.68414 16.6644 3.65566 16.6585 3.62769ZM15.834 10.3949C15.8331 12.5732 14.7847 14.6181 13.0166 15.8905L10.0007 18.0527L6.9847 15.8905C5.21661 14.6181 4.16823 12.5732 4.16732 10.3949V4.21077C6.20213 4.51483 8.27773 4.06165 10.0007 2.93717C11.7236 4.06144 13.7992 4.51463 15.834 4.21077V10.3949ZM10.0007 12.0623C9.71302 12.0623 9.47982 12.2955 9.47982 12.5832C9.47982 12.8708 9.71302 13.104 10.0007 13.104C10.2883 13.104 10.5215 12.8708 10.5215 12.5832C10.5215 12.2955 10.2883 12.0623 10.0007 12.0623Z"
          fill={props?.color ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0_3884_9196">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SecurityIcon;
